export default __webpack_public_path__ + "static/media/prizeIcon1.ec42e6f1.png";